import { ReactComponent as WatchLaterOutline } from 'assets/icons/icon-watch-later-outline.svg';

export default WatchLaterOutline;
